import React from "react";
import styles from "./Loader.module.scss";

export default function Loader() {
  return (
    <div className={styles.container}>
      <div className={styles.loaderBox}>
        <svg
          className={styles.logo}
          viewBox="0 0 1028.82 275.48"
          xmlns="http://www.w3.org/2000/svg"
          aria-label="Cargando"
          role="img"
        >
          <defs>
            <linearGradient id="loader-grad-1" x1="10.38" y1="76.63" x2="176.91" y2="234.04" gradientUnits="userSpaceOnUse">
              <stop offset="0" stopColor="#08194b" />
              <stop offset=".29" stopColor="#104093" />
              <stop offset=".7" stopColor="#08194b" />
              <stop offset=".9" stopColor="#104093" />
            </linearGradient>

            <linearGradient id="loader-grad-2" x1="113.02" y1="54.44" x2="140.91" y2="242.83" gradientUnits="userSpaceOnUse">
              <stop offset="0" stopColor="#076fba" />
              <stop offset=".61" stopColor="#075193" />
              <stop offset=".8" stopColor="#104093" />
            </linearGradient>

            <linearGradient id="loader-grad-3" x1="150.66" y1="224.45" x2="271.98" y2="15.12" gradientUnits="userSpaceOnUse">
              <stop offset="0" stopColor="#f86017" />
              <stop offset=".36" stopColor="#fb7e20" />
              <stop offset=".6" stopColor="#ff9d2b" />
            </linearGradient>

            <linearGradient id="loader-grad-4" x1="109.23" y1="218.83" x2="230.13" y2="45.2" gradientUnits="userSpaceOnUse">
              <stop offset=".16" stopColor="#0755a4" />
              <stop offset=".93" stopColor="#fb6d1a" />
            </linearGradient>

            <linearGradient id="loader-grad-5" x1="104.11" y1="121.42" x2="206.33" y2="121.42" gradientUnits="userSpaceOnUse">
              <stop offset="0" stopColor="#076fba" />
              <stop offset=".52" stopColor="#4a688e" />
              <stop offset=".78" stopColor="#f8571e" />
              <stop offset="1" stopColor="#f8571e" />
            </linearGradient>

            <linearGradient id="loader-grad-6" x1="190.13" y1="116.62" x2="190.13" y2="241.18" gradientUnits="userSpaceOnUse">
              <stop offset="0" stopColor="#fd8e21" />
              <stop offset=".44" stopColor="#f96b1f" />
              <stop offset="1" stopColor="#f8571e" />
            </linearGradient>
          </defs>

          <g className={styles.mark}>
            <path
              fill="url(#loader-grad-1)"
              d="M147.08,219.88c-1.01.58-4.16,2.55-5.61,6.54-.78,2.16-1.12,4.09-1.01,5.26-6.65,3.06-12.95,6.13-19.61,9.19-21-40.01-42.01-75.46-63.02-115.47,2.44-1.2,3.45-4.94,2.3-7.3-1.19-2.45-4.33-3.45-6.81-2.07-5.52-10.51-11.04-21.02-16.55-31.52,7.33-3.34,14.67-6.68,22-10.02,4.15,7.03,12.8,9.72,19.74,6.72,22.85,46.22,45.71,92.44,68.56,138.66Z"
            />

            <path
              fill="url(#loader-grad-2)"
              d="M174.13,207.41c-6.25,3.23-12.5,6.46-18.75,9.7-3.07.26-5.93,1.23-8.31,2.77-22.85-46.22-45.71-92.44-68.56-138.66.31-.13.62-.28.93-.44,6.35-3.3,9.66-11.06,7.58-18.38,7.45-3.26,14.91-6.45,22.36-9.71,4.42,10.57,8.84,21.13,13.27,31.7-2.28,1.11-3.37,3.71-2.64,5.94.82,2.49,3.7,3.96,6.4,3.03,15.91,38.01,31.82,76.03,47.73,114.05Z"
            />

            <path
              fill="url(#loader-grad-3)"
              d="M270.45,70.05c-7.57,11.86-15.15,23.71-22.72,35.57-2.37-.98-5.06-.1-6.32,1.94-1.4,2.27-.69,5.44,1.73,6.98-21.03,41.75-42.07,83.49-63.1,125.24-3.24-1.33-6.58-2.79-10.01-4.4-2.97-1.39-5.82-2.8-8.54-4.22.02-1.27-.09-3.31-.94-5.62-1.25-3.41-3.36-5.4-3.85-5.84-3.53-3.22-7.6-3.62-8.73-3.71-3.01-.23-5.3.5-6.24.78-7.6,2.25-17.19,1.85-24.89.02,3.25.33,6.8.31,10.55-.31,15.1-2.49,24.58-13.13,28.53-17.56,4.03-4.52,7.36-9.79,9.04-12.43,3.81-6.02,6.22-11,7.44-13.59,4.59-9.78,27.52-60.68,59.03-131.42,6.92-3.97,13.83-7.94,20.75-11.9-.51,9.59-2.6,18.64-3.11,28.23,6.6,3.91,14.79,8.35,21.39,12.26Z"
            />

            <path
              fill="url(#loader-grad-4)"
              d="M231.42,41.46c-31.51,70.74-54.44,121.64-59.03,131.42-1.22,2.59-3.63,7.57-7.44,13.59-1.68,2.65-5.01,7.91-9.04,12.43-3.95,4.43-13.42,15.07-28.53,17.56-3.75.62-7.3.64-10.55.31-1.47-.35-2.88-.75-4.19-1.2-2.42-.83-3.95-2.56-8.1-5.49,4.51-1.98,8.84-5.17,15.34-10.92,8.85-7.83,13.57-16.32,19.14-27.85,9.16-18.98,14.74-33.93,17.23-40.49,4.49-11.79,12.25-29.55,21.99-49.77,2.49.42,4.91-.95,5.8-3.2.8-2.05.18-4.44-1.57-5.91,7.94-13.36,14.98-25.83,22.92-39.18l20.88,11.97c1.52-.87,3.64-2.39,5.15-3.26Z"
            />

            <path
              fill="url(#loader-grad-5)"
              d="M104.55,210.08c5.72-2.73,10.78-6.6,15.31-10.96,4.48-4.42,8.72-9.11,12.04-14.43,1.68-2.64,3.14-5.42,4.57-8.24,1.45-2.8,2.82-5.64,4.16-8.49,2.68-5.71,5.24-11.47,7.59-17.33,2.37-5.85,4.59-11.76,6.75-17.7l3.26-8.92c1.11-2.97,2.31-5.92,3.53-8.84,4.93-11.69,10.42-23.13,16.34-34.34l.29-.55.61.07c.93.11,1.89-.06,2.72-.49.83-.42,1.5-1.12,1.89-1.96.39-.84.5-1.82.31-2.75-.19-.93-.66-1.81-1.34-2.5l-.42-.42.29-.5,11.39-19.54c3.83-6.5,7.62-13.02,11.55-19.45l-10.73,19.91c-1.78,3.33-3.6,6.62-5.42,9.93l-5.48,9.9-.13-.92c.9.87,1.56,2.01,1.84,3.25.28,1.24.18,2.58-.35,3.77-.52,1.19-1.45,2.2-2.59,2.81-1.13.62-2.45.88-3.73.76l.9-.48c-5.82,11.2-11.2,22.64-16.02,34.29-2.41,5.82-4.55,11.74-6.78,17.68-2.21,5.93-4.48,11.85-6.9,17.71-4.87,11.72-10.24,23.22-16.98,34.06-3.51,5.36-7.9,10.05-12.62,14.29-4.74,4.22-9.99,7.96-15.87,10.36Z"
            />

            <path
              fill="url(#loader-grad-6)"
              d="M138.46,217.55l3.9-.99c1.3-.31,2.6-.64,3.95-.83,1.36-.22,2.75-.06,4.08.2,1.34.28,2.65.74,3.85,1.43,2.39,1.4,4.31,3.48,5.71,5.85,1.39,2.38,2.21,5.14,2.17,7.96l-.37-.59c6.31,2.66,12.41,5.73,18.66,8.37l-1.16.42,15.09-30.84c2.5-5.15,5.05-10.27,7.62-15.38l7.69-15.35c2.58-5.11,5.13-10.23,7.76-15.31l7.96-15.22c2.67-5.07,5.35-10.12,8.13-15.13,2.76-5.02,5.49-10.04,8.3-15.03l-30.42,61.55-7.57,15.41c-2.51,5.14-5.04,10.28-7.61,15.39l-15.36,30.7-.39.77-.77-.35c-6.24-2.83-12.25-6.06-18.44-8.87l-.39-.18.02-.41c.1-2.56-.61-5.13-1.84-7.41-1.23-2.28-2.99-4.33-5.18-5.73-1.1-.7-2.32-1.18-3.6-1.51-1.28-.3-2.6-.51-3.9-.35-2.63.33-5.27.89-7.9,1.41Z"
            />

            <g className={styles.ticketDots} fill="#ffffff">
              <circle cx="51.8" cy="119.2" r="4.2" />
              <circle cx="65.4" cy="114.2" r="4.2" />
              <circle cx="79" cy="109.2" r="4.2" />
              <circle cx="92.6" cy="104.2" r="4.2" />
              <circle cx="106.2" cy="99.2" r="4.2" />

              <circle cx="186.6" cy="88.8" r="4.2" />
              <circle cx="200.2" cy="93.8" r="4.2" />
              <circle cx="213.8" cy="98.8" r="4.2" />
              <circle cx="227.4" cy="103.8" r="4.2" />
              <circle cx="241" cy="108.8" r="4.2" />
            </g>

            <path
              className={styles.loaderStar}
              fill="#ffffff"
              d="M236.5 42.5 L247.2 68.5 L275.2 70.7 L254 89 L260.6 116.4 L236.5 101.8 L212.4 116.4 L219 89 L197.8 70.7 L225.8 68.5 Z"
            />

            <g
              className={styles.loaderSparks}
              fill="none"
              stroke="#ff7a1a"
              strokeWidth="8"
              strokeLinecap="round"
            >
              <path d="M229 17 L224 0" />
              <path d="M260 17 L269 0" />
              <path d="M284 43 L312 27" />
              <path d="M295 76 L326 75" />
              <path d="M277 105 L298 127" />
            </g>
          </g>

          <g className={styles.word}>
            <path className={`${styles.letter} ${styles.l1}`} d="M321.91,209.86h-62.21l-11.87,28.71h-31.78l59.72-133.99h30.63l59.91,133.99h-32.54l-11.87-28.71ZM312.15,186.32l-21.25-51.3-21.25,51.3h42.49Z" />
            <path className={`${styles.letter} ${styles.l2}`} d="M369.77,225.37l10.53-23.35c11.29,8.23,28.14,13.97,44.22,13.97,18.38,0,25.84-6.13,25.84-14.36,0-25.08-77.91-7.85-77.91-57.62,0-22.78,18.38-41.73,56.47-41.73,16.84,0,34.07,4.02,46.51,11.87l-9.57,23.54c-12.44-7.08-25.27-10.53-37.13-10.53-18.38,0-25.46,6.89-25.46,15.31,0,24.69,77.91,7.66,77.91,56.85,0,22.4-18.57,41.54-56.85,41.54-21.25,0-42.69-6.32-54.55-15.5Z" />
            <path className={`${styles.letter} ${styles.l3}`} d="M502.42,104.58h31.01v108.73h67.19v25.27h-98.2V104.58Z" />
            <path className={`${styles.letter} ${styles.l4}`} d="M607.32,171.58c0-39.81,31.01-69.29,73.31-69.29s73.31,29.29,73.31,69.29-31.2,69.29-73.31,69.29-73.31-29.48-73.31-69.29ZM722.55,171.58c0-25.46-17.99-42.88-41.92-42.88s-41.92,17.42-41.92,42.88,17.99,42.88,41.92,42.88,41.92-17.42,41.92-42.88Z" />
            <path className={`${styles.letter} ${styles.l5}`} d="M777.3,104.58h31.01v108.73h67.19v25.27h-98.2V104.58Z" />
            <path
              className={`${styles.letter} ${styles.l6}`}
              d="M984.84,209.78h-62.38l-11.9,28.79h-31.86l59.88-134.35h30.71l60.07,134.35h-32.63l-11.9-28.79ZM975.05,186.17l-21.3-51.44-21.3,51.44h42.61Z"
            />
          </g>
        </svg>

        <span className={styles.loadingText}>Cargando...</span>
      </div>
    </div>
  );
}